export enum NodeValue {
  WhiteSpace = "&nbsp;",
}

export enum TagName {
  Anchor = "A",
  Break = "BR",
  Div = "DIV",
  Span = "SPAN",
  UnorderedList = "UL",
  OrderedList = "OL",
  Input = "INPUT",
  TextArea = "TEXTAREA",
}

export const isElementFocusable = (
  target: HTMLElement | EventTarget | null | undefined
): target is HTMLElement =>
  target instanceof HTMLElement &&
  ([TagName.Input, TagName.TextArea].includes(target.tagName as TagName) ||
    target.isContentEditable)
